document.addEventListener("DOMContentLoaded", () => {

  // Quantity buttons
  document.addEventListener("click", (e) => {
    if (e.target.classList.contains("qty-btn")) {
      const input = e.target.closest(".quantity-wrapper").querySelector(".quantity-input");
      let value = parseInt(input.value, 10);
      if (e.target.classList.contains("plus")) value++;
      if (e.target.classList.contains("minus") && value > 1) value--;
      input.value = value;
    }
  });

  // Add to Cart function
  async function addToCart(variantId, quantity = 1) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      });

      const data = await response.json();

      // Use Dawn's built-in cart drawer toggle
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        // Refresh cart drawer via Shopify's sections API
        const sections = await fetch("/?sections=cart-drawer")
          .then(res => res.json());

        if (sections["cart-drawer"]) {
          cartDrawer.innerHTML = sections["cart-drawer"];
        }

        // Open the drawer programmatically
        cartDrawer.classList.add("is-open");
        document.body.classList.add("overflow-hidden"); // prevent background scroll
      }

    } catch (err) {
      console.error("Add to cart failed:", err);
    }
  }

  // Hook into all product forms
  document.querySelectorAll(".product-card-form").forEach(form => {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const variantId = form.querySelector("[name='id']").value;
      const quantity = parseInt(form.querySelector("[name='quantity']")?.value || 1, 10);
      addToCart(variantId, quantity);
    });
  });
});
